module.exports = __webpack_public_path__ + "images/morgan_small914fafb4b93c01e62d806b18b61932ce.png";